import { DealRoomRequiredVisibleInfo } from 'models/DealRoom';

export type DealRoomFieldBaseName = {
  [K in keyof DealRoomRequiredVisibleInfo]: K extends `${infer Base}RequiredVisibleInfo`
    ? Base
    : never;
}[keyof DealRoomRequiredVisibleInfo];

export const DEAL_ROOM_DEFAULT_REQUIRED: Record<
  DealRoomFieldBaseName,
  boolean
> = {
  amountFrom: true,
  amountTo: true,
  amount: true,
  averageStockValue: false,
} as const;

export const getIsDealRoomDefaultRequired = (key: DealRoomFieldBaseName) => {
  return DEAL_ROOM_DEFAULT_REQUIRED?.[key] || false;
};
